import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Conversation, AIContextType } from '../types';

const AIContext = createContext<AIContextType | undefined>(undefined);

interface AIProviderProps {
  children: ReactNode;
}

export function AIProvider({ children }: AIProviderProps) {
  const [activeConversation, setActiveConversation] = useState<Conversation | null>(null);
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);

  return (
    <AIContext.Provider
      value={{
        activeConversation,
        setActiveConversation,
        isPanelOpen,
        setIsPanelOpen,
      }}
    >
      {children}
    </AIContext.Provider>
  );
}

export function useAI(): AIContextType {
  const context = useContext(AIContext);
  if (context === undefined) {
    throw new Error('useAI must be used within an AIProvider');
  }
  return context;
}
